import EndPoints from '@services/endpoints';
import TopUpsItemDto from '../models/dto/top-ups-item.dto';
import { AxiosResponse } from 'axios';
import axiosClient from '@services/axiosClient';
import IPaginatedParams from '@models/paginated-params';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedesponse from '@models/paginated-reponse';
import { ITopUps } from '../models/top-ups';
import { ITopUpDetails } from '../models/top-up-details';
import { IConsumption } from '../models/consumptions';

export const createTopUps = async (
  newTopUps: TopUpsItemDto,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.post(EndPoints.credit.createTopUps, newTopUps);
};

export const getTopUps = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<ITopUps>>> => {
  return await axiosClient.post(
    EndPoints.credit.getTopUps(paginatedParams),
    searchCriteria,
  );
};

export const getCreditsConsumption = async (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
): Promise<AxiosResponse<IPaginatedesponse<IConsumption>>> => {
  return await axiosClient.post(
    EndPoints.credit.getCreditsConsumption(paginatedParams),
    searchCriteria,
  );
};

export const cancelTopUp = async (
  topUpId: string,
): Promise<AxiosResponse<null>> => {
  return await axiosClient.delete(EndPoints.credit.deleteTopUps(topUpId));
};

export const getDetailsTopUps = async (
  topUpId: string,
): Promise<AxiosResponse<ITopUpDetails>> => {
  return await axiosClient.get(EndPoints.credit.getDetailsTopUp(topUpId));
};
